"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SidebarContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.SidebarContainer = styled_components_1.default.nav `
  box-sizing: border-box;
  border-right: 1px solid ${({ theme }) => theme.ui01};
  display: flex;
  background-color: ${({ theme }) => theme.ui06};
  color: ${({ theme }) => theme.textColor01};
  flex-direction: column;
  padding: 4px ${({ theme }) => theme.spacing03};
  margin: 0;
  width: ${({ collapsed }) => (collapsed ? '53px' : '217px')};
  height: 100%;
`;
